import { getAuthToken } from './authApi';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

const makeRequest = async (url, options = {}) => {
  const token = getAuthToken();
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });
  const data = await response.json();
  if (!response.ok) {
    const err = new Error(data.message || data.error || `HTTP ${response.status}`);
    err.status = response.status;
    err.details = data;
    throw err;
  }
  return data;
};

// ── Entries CRUD ─────────────────────────────────────────────────────────────

export const getEntries = () =>
  makeRequest(`${API_BASE_URL}/api/url-registry/entries`);

export const getEntry = (id) =>
  makeRequest(`${API_BASE_URL}/api/url-registry/entries/${id}`);

export const createEntry = (payload) =>
  makeRequest(`${API_BASE_URL}/api/url-registry/entries`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const updateEntry = (id, payload) =>
  makeRequest(`${API_BASE_URL}/api/url-registry/entries/${id}`, {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

export const deleteEntry = (id) =>
  makeRequest(`${API_BASE_URL}/api/url-registry/entries/${id}`, {
    method: 'DELETE',
  });

// ── Probe ────────────────────────────────────────────────────────────────────

export const probeUrl = (url) =>
  makeRequest(`${API_BASE_URL}/api/url-registry/probe`, {
    method: 'POST',
    body: JSON.stringify({ url }),
  });
